<style>
    .modal{overflow:auto!important;}
</style>    
<template>
    <!-- Remember to include jQuery :) -->    
    <div class="hello" style="text-align:right;">

        <select v-model="filter_gender" 
           style="margin-left:5px; border-radius:4px; padding:4px 5px; background:#fff; font-size:12px;">
            <option value="">ALL</option>
            <option value="2">여자</option>
            <option value="1">남자</option>
        </select>
        <select @change="changeType()" v-model="filtertype"
            style="margin-left:5px; border-radius:4px; padding:4px 5px; background:#fff; font-size:12px;">
            <option value="hair" :selected="filtertype == 'hair'">헤어</option>
            <option value="clothes" :selected="filtertype == 'clothes'">옷</option>
            <option value="weapon" :selected="filtertype == 'weapon'">액세서리</option>
            <option value="shoes" :selected="filtertype == 'shoes'">신발</option>
            <option value="face" :selected="filtertype == 'face'">표정</option>
            <option value="pet" :selected="filtertype == 'pet'">펫</option>
        </select>
        <select v-model="filter"
            style="margin-left:5px; border-radius:4px; padding:4px 5px; background:#fff; font-size:12px;">
            <option value="ALL">ALL</option>
            <option v-for="tier in this.$parent.tiers" :key="tier.tier" :value="tier.score">{{ tier.tier}}</option>
        </select>&nbsp;&nbsp;
        <div class="tab-content">
            <!-- <router-view/> -->
            <div>

                <div class="item_box" v-for="item in items">
                    <div class="item_box_title"><span
                            :style="'padding:2px 4px;color:#fff;border-radius:4px;' + (item.gender == 1 ? 'background:#3f6ad8;' : item.gender == 3 ? '' : 'background:#d92550;')"><strong>{{ item.gender == 1 ? "남" : item.gender == 3 ? "" : "여" }}</strong></span>
                        {{ item.name }}<span v-if="item.new"
                            style="background:#007bff; color:#fff; font-size:11px; padding:1px 3px; border-radius:4px;">{{ item.new }}</span><span
                            style="color: #3cff00; padding: 2px 4px; border-radius: 4px; font-size:10px; font-weight:bold;">{{ item.tag}}</span>
                    </div>
                    <div class="item_box_item" style="position:relative;"><img
                            :src="'https://avatar.useschool.co.kr/avatar/img/item/' + item.type + '/' + item.code + '.png'">
                        <div style="position:absolute; left:3px; top:3px;"><span
                                style=" color:#333; font-size:10px; font-weight:bold; padding:0px 4px; border-radius:4px;"
                                v-bind:style="{backgroundColor: item.tier == 'EVENT' ? '#55ff19' : '#FFB400'}">{{ item.tier }}</span>
                        </div>
                    </div>
                    <div class="item_box_price_fame" v-if="item.price[0] && item.price[0].price != 0 ">
                        {{item.price[0].price }} <span><img
                                src="https://useschool.co.kr//UbestA/Ubesta2_new/img/buy_carat.png"
                                style="width:20px;"></span> </div>
                    <div class="item_box_buy_fame" v-on:click="openItemDialog(item);" v-if="item.price[0].price != 0"
                        data-toggle="modal" data-target="#exampleModal">선물</div>
                    <!-- Modal HTML embedded directly into document -->



                    <br>
                    <div style="clear: both"></div>
                    <!-- <div style="text-align: center; color: #fff; font-size: 14px; margin-top: 20px;">◀ 1 / 2 ▶</div> -->

                </div>
                <div style="clear:both">&nbsp;</div>
                <div style="text-align:center; position:relative; top:00px; ">
                    <router-link :to="(+currentPage - 1).toString()" v-if="currentPage > 1"><span
                            style="font-size: 12px; padding:2px 4px;" class="btn btn-danger">◀&nbsp;PREV</span>
                    </router-link>&nbsp;
                    <router-link :to="(+currentPage + 1).toString()" v-if="items.length >= 8"><span
                            style="font-size: 12px; padding:2px 4px;" class="btn btn-primary">▶&nbsp;NEXT </span>
                    </router-link>
                </div>
            </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:#202020; color:#bcbcbc;">
                    <div class="modal-header" style="border-bottom:1px solid #333; margin:10px 16px;">
                        <h5 class="modal-title" id="exampleModalLabel">아이템 선물하기</h5>
                        <button type="button" class="close" style="color:#fff;" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="overflow:auto;">
                        <div style=text-align:center;>
                            <div
                                style="border-radius: 10px; display:inline-block; padding:2px 14px;  text-align: center; font-size:18px; background:#ffb400; font-weight:bold;color:#333; margin-bottom:20px;  letter-spacing: -1.4px;">
                                {{ modalDesc.item.name }}</div>
                            <div style="text-align:center;"><img
                                    :src="'//avatar.useschool.co.kr/avatar/img/item/' + modalDesc.item.type + '/' + modalDesc.item.code + '.png'">
                            </div>
                        </div>

                        <div style="height:1px; background:#333333; margin-top: 8px;  "></div>
                        <div style="height:1px; background:#111; margin-bottom: 8px;"></div>
                        <label v-for="payMethod in modalDesc.item.price" style="display:block; text-align:left;"
                            v-bind:key="payMethod.id">
                            <input type="radio" :value="payMethod.id" v-model="modalDesc.buyPrice">
                            <span
                                :style="payMethod.period < 0 ? 'color: #ffb400; ' : ''">{{ payMethod.price }}{{payMethod.type}}
                                ({{ payMethod.period < 0 ? "무제한" : payMethod.period + "일"}})</span><br></label>

                        <div style="height:1px; background:#333333; margin-top: 8px;"></div>
                        <div style="height:1px; background:#111; margin-bottom: 8px;"></div>

                        <div
                            style="font-size: 14px; font-weight: normal; color: #fff; line-height: 16px;text-align:left;">
                            {{ modalDesc.item.description }}<br><br>
                            <span style="color: #00f6ff; font-weight: 600;">{{ modalDesc.item.skill }}</span>
                        </div>

                    </div>
                    <div class="modal-footer" style="border-top:1px solid #333;">
                        <button type="button" class="btn btn-danger" data-dismiss="modal"
                            :disabled="modalDesc.buyPrice == ''" data-toggle="modal"
                            data-target="#exampleGiftModal" @click="studentSearchRes = []">선택</button>
                        <button type="button" class="btn btn-light" data-dismiss="modal">닫기</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="exampleGiftModal" tabindex="-1" role="dialog"
            aria-labelledby="exampleGiftModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:#202020; color:#bcbcbc;">
                    <div class="modal-header" style="border-bottom:1px solid #333; margin:10px 16px;">
                        <h5 class="modal-title" id="exampleGiftModalLabel">아이템 선물하기</h5>
                        <button type="button" class="close" style="color:#fff;" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        
                        <div style="height:1px; background:#111; margin-bottom: 8px;"></div>
                        <button style="float:left;" class="btn btn-secondary" :class="{'active': selectMode == 'my'}" @click="selectMode='my';studentSearchRes=[];">내 친구찾기</button>
                        <button style="float:left;" class="btn btn-secondary" :class="{'active': selectMode == 'class'}" @click="selectMode='class';find_class();">우리반 친구찾기</button>
                        <template v-if="selectMode == 'my'">
                        <input class="form-control" id="studentDataList" v-model="studentNameType"
                            placeholder="학생명이나 아이디를 입력하세요" @input="studentAutoComplete" @paste="studentAutoComplete">
                        <div class="list-group" style="text-align:left; max-height:260px; overflow:auto;">
                            <button type="button" class="list-group-item list-group-item-action"
                                v-for="(student, intMember) in studentSearchRes"
                                @click="addSendTgt(student, intMember)"
                                :disabled="!intMember" :key="intMember"><template v-if="student.name">{{ student.name }} ({{student.username}})</template><template v-else>{{ student }} </template></button>
                        </div>
                        </template>
                        <template v-if="selectMode == 'class'">
                            <div style="width:465px; height:300px; background:#fff; float:left; text-align:left;
                                        margin: 0 auto; margin-bottom:10px; overflow:auto;">
                                        <div style="width:100%;padding:10px; margin:0 auto; text-align:center; color:black;" v-if="studentSearchRes.error">
                                        <template v-if="studentSearchRes.type == 'SCL'">
                                            소속된 반 친구가 없어요~<br>
                                            학교 반 등록을 신청해 주세요.<br>
                                            관련 문의는 1:1게시판에 남겨주세요.
                                        </template>
                                        <template v-else>
                                            소속된 반 친구가 없어요~ <br>
                                            클래스 튜터 관리를 신청해 주세요.<br>
                                            관련 문의는 1:1게시판에 남겨주세요.

                                        </template>
                                        </div>
                                <div v-else style="display:flex; width:90%; padding:10px; margin:0 auto; text-align:center; line-height:75px;" v-for="(student, intMember) in studentSearchRes" :key="intMember">
                                    <div style="width:25%; color:#252525;"><img src="../assets/img/boy.png" style="width:70px;" :onload="'loadAvatarHere(this, ' + intMember + ')'"></div>
                                    <div style="width:25%; color:#252525;">{{ student.name }}</div> 
                                    <div style="width:25%; color:#252525;">{{ student.username }}</div> 
                                    <div style="width:25%;">
                                        <button class="btn btn-danger" style="font-size:13px;" @click="addSendTgt(student, intMember)">선택</button>
                                        </div> 
                                </div>
                            </div>    
                        </template><br>
                        <div style="text-align:left;">
                        <span class="badge badge-pill badge-primary" v-for="(student, id) in sendTgt"
                            @click="removeTgt(id)" :key="id">{{ student.name }} ({{student.username}}) ×</span>
                        </div>    
                        <div style="height:1px;"></div>
                        <select class="form-control" v-model="modalDesc.req_message">
                            <option value="" selected>친구에게 보내는 메시지를 선택해 주세요</option>
                            <option v-for="msg in giftMsgs" :key="msg" :value="msg">{{msg}}</option>
                        </select>
                        <div style="height:1px; background:#111; margin-bottom: 8px;"></div>

                        <div style="font-size: 13px; font-weight:300; color: #fff; line-height: 18px; text-align:left;">
                            <p style="font-size: 15px; line-height:8px; padding-top:12px;">※ 이용안내</p>
                                            - 아바타샵에 1회 이상 접속하지 않은 친구에게는 선물할 수 없습니다.<br>
 - 선물하기 즉시 Carat 점수는 차감되며, 선물받은 친구가 거절한 경우 차감된 Carat 점수는 복구됩니다.<br>
 - 선물 받은 친구가 수락 또는 거절하기 전까지는 My room > 보낸 선물함에서 취소할 수 있으며, 차감된 Carat 점수는 복구됩니다.<br>
 - 여러 명의 친구에게 선물을 하는 경우 합산 Carat 점수를 초과해서 선물할 수 없습니다.<br>
 - 선물 받는 친구의 성별과 선물하려는 아이템의 성별이 동일해야만 선물이 가능합니다.

                        </div>

                    </div>
                    <div class="modal-footer" style="border-top:1px solid #333;">
                        <button type="button" class="btn btn-danger" :data-dismiss="(this.sendTgt.length && this.modalDesc.req_message) ? 'modal': ''"
                            @click="sendGift">선물하기</button>
                        <button type="button" class="btn btn-light" data-dismiss="modal"
                            @click="sendTgt = []">닫기</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import axios from 'axios';
    export default {
        name: 'home',
        methods: {
            fetchData(type, page) {
                this.currentType = type;
                this.currentPage = page;
                axios.get(this.$parent.persistent.apiUrl + 'getItemList.php?type=' + type + '&page=' + parseInt(page) +
                        '&uid=' + this.$parent.loginID + '&filter=' + this.filter +'&is_gift=true' + (this.filter_gender ? '&gender=' + this.filter_gender : ''))
                    .then(response => {
                        // console.log(response.data)
                        this.items = response.data.items
                    }).catch((error) => console.log(error));
            },
            openItemDialog(item) {
                this.sendTgt = {}
                this.modalDesc.item = item;
            },
            buyItem() {
                axios.get(this.$parent.persistent.apiUrl + 'buyItem.php?priceId=' + this.modalDesc.buyPrice + '&uid=' +
                        this.$parent.loginID)
                    .then(response => {
                        // console.log(response.data)
                        // this.items = response.data.items
                        if (response.data.status == "error") {
                            this.$parent.alert(response.data.reason)
                        } else {
                            this.$parent.alert("구매 성공")
                            this.$parent.fetchMyInfo()
                        }
                    }).catch((error) => console.log(error));
            },
            studentAutoComplete(e) {
                if (this.cancelToken) {
                    this.cancelToken.cancel();
                }
                this.cancelToken = axios.CancelToken.source();
                axios.get(this.$parent.persistent.apiUrl + 'memberQuery.php?uid=' + this.$parent.loginID + '&type=' + this.selectMode + '&gender=' + (this.modalDesc.item.gender == 2 ? 'F' : 'M') + '&query=' + e.target.value, {
                        cancelToken: this.cancelToken.token
                    })
                    .then(response => {
                        this.cancelToken = null;
                        // console.log(response.data)
                        // this.items = response.data.items
                        /*if(response.data.status == "error"){
                          this.$parent.alert(response.data.reason)
                        } else {
                          this.$parent.alert("구매 성공")
                          this.$parent.fetchMyInfo()
                        }*/
                        if(response.data.error){
                            this.studentSearchRes = []
                        } else {
                        this.studentSearchRes = response.data;
                        }
                        this.$forceUpdate()
                    }).catch((error) => console.log(error));
            },
            find_class(){
                axios.get(this.$parent.persistent.apiUrl + 'memberQuery.php?uid=' + this.$parent.loginID + '&type=' + this.selectMode + '&gender=' + (this.modalDesc.item.gender == 2 ? 'F' : 'M'))
                    .then(response => {
                        
                        // console.log(response.data)
                        // this.items = response.data.items
                        /*if(response.data.status == "error"){
                          this.$parent.alert(response.data.reason)
                        } else {
                          this.$parent.alert("구매 성공")
                          this.$parent.fetchMyInfo()
                        }*/
                        this.studentSearchRes = response.data;
                        console.log(response.data)
                        this.$forceUpdate()
                    }).catch((error) => console.log(error));
            },
            addSendTgt(displayName, intMember) {
                axios.get(this.$parent.persistent.apiUrl + 'convertUUIDtoID.php?userUUID=' + intMember)
                    .then(response => {
                        if (response.data.id) {
                            this.sendTgt[response.data.id] = displayName;
                            if(this.selectMode == 'my') this.studentSearchRes = {}
                            this.studentNameType = "";
                        } else {
                            this.$parent.alert("해당 사용자는 아바타몰에 접속한 이력이 없어 선물을 받을 수 없습니다.");
                        }
                        this.$forceUpdate()
                    }).catch((error) => console.log(error));

            },
            removeTgt(id) {
                delete this.sendTgt[id]
                this.$forceUpdate()
            },
            sendGift() {
                // execute
                if(!this.modalDesc.req_message){
                    this.$parent.alert("친구에게 보내는 메시지를 선택해 주세요.")
                    return;
                }
                if(this.sendTgt.length){
                    this.$parent.alert("선물할 친구를 선택해 주세요.")
                    return;
                }
                axios.get(this.$parent.persistent.apiUrl + 'sendGift.php?priceId=' + this.modalDesc.buyPrice + '&uid=' +
                        this.$parent.loginID + '&tgtuid=' + Object.keys(this.sendTgt).join(",") + '&req_message=' + this.modalDesc.req_message)
                    .then(response => {
                        // console.log(response.data)
                        // this.items = response.data.items
                        if (response.data.status == "error") {
                            this.$parent.alert(response.data.reason)
                        } else {
                            this.$parent.alert("선물 성공")
                            this.$parent.fetchMyInfo()
                        }
                    }).catch((error) => console.log(error));
            },
            changeType() {
                this.$router.push("../" + this.filtertype + "/1");
            }
        },
        watch: {
            '$route.params': {
                handler(newValue) {
                    const {
                        type,
                        page
                    } = newValue

                    this.fetchData(type, page)
                    this.filtertype=type;
                },
                immediate: true,
            },
            'filter': {
                handler() {
                    this.fetchData(this.currentType, 1)
                }
            },
            'filter_gender': {
                handler() {
                    this.fetchData(this.currentType, 1)
                }
            }
        },
        data() {
            return {
                items: [],
                modalDesc: {
                    item: {},
                    buyPrice: "",
                    req_message: ""
                },
                alertModal: "",
                currentPage: 1,
                currentType: "weapon",
                studentNameType: "",
                studentSearchRes: {},
                cancelToken: null,
                sendTgt: {},
                filter: "ALL",
                filtertype: this.$route.params.type,
                selectMode: "my",
                giftMsgs: [
                    "정말 잘하고 있어요! 오늘도 파이팅!",
                    "Congratulations! 축하합니다.",
                    "내 선물 받고 힘내! 우리 열심히 하자 ",
                    "토닥토닥 정말 잘했어! 넌 최고야",
                    "선물 당첨! 열심히 한 너에게만 주는거야"
                ],
                filter_gender: ""
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>